import UIIcon from 'UIComponents/icon/UIIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled, { css, keyframes } from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BaseBulkActionsButtonIcon = ({
  icon,
  inDropdown
}) => {
  if (!icon || inDropdown) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIIcon, {
    "data-test-id": "base-bulk-actions-button-icon",
    className: "m-right-1",
    name: icon
  });
};
const fadeInOut = keyframes(["0%{opacity:1;}50%{opacity:.2;}100%{opacity:1;}"]);
const FadingInAndOut = styled.span.attrs(props => ({
  'data-test-id': props.animate ? 'loading-animation-true' : 'loading-animation-false'
})).withConfig({
  displayName: "BaseBulkActionButton__FadingInAndOut",
  componentId: "dqypmo-0"
})(["align-items:center;display:flex;opacity:1;", ";"], props => props.animate ? css(["animation:", " 1.5s infinite;"], fadeInOut) : 'animation: none');
export const BaseBulkActionButton = ({
  'aria-label': ariaLabel,
  'data-selenium-test': dataSeleniumTest,
  'data-test-id': dataTestId,
  disabled = false,
  disabledTooltip,
  icon = '',
  inDropdown = false,
  isLoading,
  children,
  onClick
}) => {
  const isButtonDisabled = disabled || isLoading;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    placement: "bottom",
    title: disabledTooltip,
    children: /*#__PURE__*/_jsx(Button, {
      "aria-label": ariaLabel,
      "aria-disabled": isButtonDisabled,
      "data-test-id": dataTestId,
      "data-selenium-test": dataSeleniumTest,
      disabled: isButtonDisabled,
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsxs(FadingInAndOut, {
        animate: Boolean(isLoading),
        children: [/*#__PURE__*/_jsx(BaseBulkActionsButtonIcon, {
          icon: icon,
          inDropdown: inDropdown
        }), children]
      })
    })
  });
};